import React, { useState, useEffect, useRef } from "react";
// Optional: smooth scrolling with Lenis (install with `npm i @studio-freight/lenis`)
import Lenis from "@studio-freight/lenis";
import "./App.css";
import Aboutus from "./components/Aboutus";
import Contact from "./components/Contact";
import Joinus from "./components/Joinus";
import Slider from "./components/Slider";
// import NavbarMain from "./components/NavbarMain";
import NavbarMain from "./components/Navbar";
import Whyus from "./components/Whyus";
import EmailForm from "./components/emailForm";
import { Route, Routes } from "react-router-dom";
import AppTerms from "./Pages/AppTerms";
import LicenseeTerms from "./Pages/LicenseeTerms";
import PremiumFeatures from "./Pages/PremiumFeatures";
import LandingPage from "./Pages/LandingPage";
import CookieConsentBanner from "./components/CookieBanner";
import AnimateOnScroll from "./components/AnimateOnScroll";
import CaptureShareBroadcast from "./components/CaptureShareBroadcast";
import FAQ from "./components/FAQs";
import { faqsFans } from "./components/FAQs_QandAOnly";
import NewLandPage from "./Pages/VupopForFans";
import VupopForBroadcasters from "./Pages/VupopForBroadcasters";
import VupopForBrands from "./Pages/VupopForBrands";
import ScrollToTop from "./components/ScrollToTop";
import ContactUs from "./components/ContactUs";
import Footer from "./components/Footer";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import NotFound from "./components/NotFound";
import CustomToaster from "./helper/CustomToaster";
import { FanContent } from "./components/FanContent";
import DocsPage from "./Pages/docs/EditorDocs/DocsPage";
import Docs from "./Pages/docs/ManagerDocs/Docs";
import DocsLanding from "./Pages/docs/DocsLanding";
import ReferralPage from "./components/Referral/ReferralPage";
import QCardRedirect from "./components/QCardRedirect";
import ReferralRedirect from "./components/ReferralRedirect";
import { StripeReturn, StripeRefresh } from "./Pages/StripeHandoff";

function App() {
  const [showEmailForm, setShowEmailForm] = useState(false);
  const [isSubmit, setIsSubmit] = useState(true);

  // useEffect(() => {
  //   const formSubmitted = localStorage.getItem('formSubmitted');

  //   if (!formSubmitted) {
  //     setShowEmailForm(true);
  //   }

  //   const handleScroll = () => {
  //     const scrollY = window.scrollY || document.documentElement.scrollTop;
  //     if (scrollY > 500 && !formSubmitted) { // Show form only if not submitted
  //       setShowEmailForm(true);
  //     }
  //   };

  //   window.addEventListener("scroll", handleScroll);

  //   // Cleanup the event listener on component unmount
  //   return () => {
  //     window.removeEventListener("scroll", handleScroll);
  //   };
  // }, []);

  const handleFormSubmit = () => {
    localStorage.setItem("formSubmitted", "true");
    setShowEmailForm(false);
  };
  // const lenisRef = React.useRef(null);
  //   // Initialize Lenis once to enable smooth scrolling across the app.
  //   useEffect(() => {
  //     // Guard in case dependency isn't installed yet — avoids breaking the app at runtime.
  //     if (!Lenis) return;

  // const lenis = new Lenis({
  //   duration: 1.2,
  //   easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
  //   smooth: true,
  // });

  // lenisRef.current = lenis;

  //     let rafId;
  //     const raf = (time) => {
  //       lenis.raf(time);
  //       rafId = requestAnimationFrame(raf);
  //     };

  //     rafId = requestAnimationFrame(raf);

  //     return () => {
  //       if (rafId) cancelAnimationFrame(rafId);
  //       if (lenis && typeof lenis.destroy === 'function') {
  //         try { lenis.destroy(); } catch (e) {}
  //       }
  //     };
  //   }, []);
  const Homepage = () => {
    React.useEffect(() => {
      const target = sessionStorage.getItem("scrollTarget");
      if (target) {
        sessionStorage.removeItem("scrollTarget");
        // Small delay to let the page render first
        setTimeout(() => {
          const el = document.getElementById(target);
          if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }, 100);
      }
    }, []);

    return (
      <>
        <AnimateOnScroll>
          <NavbarMain />
        </AnimateOnScroll>
        {/* <NavbarMain /> */}
        <AnimateOnScroll>
          <Slider />
        </AnimateOnScroll>
        <div id="features">
          <AnimateOnScroll>
            <CaptureShareBroadcast />
          </AnimateOnScroll>
        </div>
         <div id="fan-content">
          <AnimateOnScroll>
            {" "}
            <FanContent/>
          </AnimateOnScroll>
        </div>
        <div id="about-us">
          <AnimateOnScroll>
            {" "}
            <Aboutus />
          </AnimateOnScroll>
        </div>

        <div id="faqs">
          <AnimateOnScroll>
            <FAQ questions={faqsFans} />
          </AnimateOnScroll>
        </div>

        {/* <div id="features">
       
          <Whyus />
    
      </div>
     */}

        {/* <AnimateOnScroll> */}
        <div id="contact">
          {/* <AnimateOnScroll><Joinus /></AnimateOnScroll> */}
          {/* <AnimateOnScroll><Contact /></AnimateOnScroll> */}
          <AnimateOnScroll>
            <Footer />
          </AnimateOnScroll>
          <AnimateOnScroll>
            <CookieConsentBanner />
          </AnimateOnScroll>
        </div>
        {/* </AnimateOnScroll> */}
        {/* {showEmailForm && isSubmit &&(
        <div id="email-form">
          <EmailForm onClose={()=> setIsSubmit(false)} />
        </div>
      )} */}
      </>
    );
  };

  return (
    <div className="">
      <CustomToaster />

      {/* {showEmailForm && isSubmit &&(
        <div id="email-form">
          <EmailForm onClose={()=> setIsSubmit(false)} />
        </div>
      )} */}
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/legal/app-terms" element={<AppTerms />} />
        <Route path="/legal/licensee-terms" element={<LicenseeTerms />} />
        <Route path="/premium" element={<PremiumFeatures />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/app" element={<LandingPage />} />
        <Route path="/VupopForFans" element={<NewLandPage />} />
        <Route
          path="/VupopForBroadcasters"
          element={<VupopForBroadcasters />}
        />
        <Route path="/VupopForBrands" element={<VupopForBrands />} />
        <Route path="/docs" element={<DocsLanding/>} />
         <Route path="/docs/editor" element={<DocsPage/>} />
         <Route path="/docs/manager" element={<Docs/>} />
        <Route path="/ContactUs" element={<ContactUs />} />
        <Route path="/referral-program" element={<ReferralPage/>} />
        <Route path="/q-card/:id" element={<QCardRedirect />} />
        <Route path="/referral/:referralCode" element={<ReferralRedirect />} />
        <Route path="/stripe/return" element={<StripeReturn />} />
        <Route path="/stripe/refresh" element={<StripeRefresh />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}

export default App;
